import "./../MonacoEditorWorkers";
import { languages, Emitter } from "monaco-editor/esm/vs/editor/editor.api";
import { typeDeclarationLoader } from "./TypeDeclarationLoader";
import { DefinitionAdapter } from "../adapters/DefinitionAdapter";

const defaultCompilerOptions: languages.typescript.CompilerOptions = {
  lib: ["esnext", "dom", "dom.iterable", "scripthost"],
  reactNamespace: "React",
  jsx: languages.typescript.JsxEmit.React,
  target: languages.typescript.ScriptTarget.ESNext,
  module: languages.typescript.ModuleKind.ESNext,
  moduleResolution: languages.typescript.ModuleResolutionKind.NodeJs,
  allowNonTsExtensions: true,
  allowJs: false,
  allowSyntheticDefaultImports: true,
  stripInternal: false,
  strict: true /* Enable all strict type-checking options. */,
  noImplicitAny: true /* Raise error on expressions and declarations with an implied "any" type. */,
  strictNullChecks: true /* Enable strict null checks. */,
  noImplicitThis: true /* Raise error on "this" expressions with an implied "any" type. */,
  alwaysStrict: true /* Parse in strict mode and emit "use strict" for each source file. */,
  noUnusedLocals: true /* Report compilation errors on unused locals. */,
  noUnusedParameters: true /* Report errors on unused parameters. */,
  noImplicitReturns: true /* Report error when not all code paths in function return a value. */,
  noFallthroughCasesInSwitch: false /* DON'T Report errors for fallthrough cases in switch statement. It is possible to use this feature safely, and we have been doing that for years. */,
  experimentalDecorators: true,
  forceConsistentCasingInFileNames: true,
  esModuleInterop: true,
  incremental: true,
  resolveJsonModule: true,
  baseUrl: ".",
  sourceMap: true,
};

export namespace LanguageService {

  const emmiter = new Emitter<void>();
  export const onTypeDefinitionsLoaded = emmiter.event;

  export const setTypeScriptOptions = () => {
    languages.typescript.typescriptDefaults.setCompilerOptions(defaultCompilerOptions);
    languages.typescript.typescriptDefaults.setEagerModelSync(true);
    languages.registerDefinitionProvider("typescript", new DefinitionAdapter());
  };

  export const addTypeDefinitions = async (paths: string[]) => {
    languages.typescript.typescriptDefaults.setDiagnosticsOptions({
      noSemanticValidation: true,
      noSuggestionDiagnostics: true,
      noSyntaxValidation: true,
    });

    console.time("loadTypeDeclarations");
    const typeDeclarations = await typeDeclarationLoader.loadTypeDeclarations(paths);
    console.timeEnd("loadTypeDeclarations");

    console.time("monaco-editor setExtraLibs");
    languages.typescript.typescriptDefaults.setExtraLibs(typeDeclarations)

    const handle = languages.typescript.typescriptDefaults.onDidExtraLibsChange(() => {
      console.timeEnd("monaco-editor setExtraLibs");
      languages.typescript.typescriptDefaults.setEagerModelSync(true);
      languages.typescript.typescriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: false,
        noSuggestionDiagnostics: false,
        noSyntaxValidation: false,
      });
      emmiter.fire();
      handle.dispose();
    });
  };
}